/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatLazy_viewer">;
    readonly " $refType": "PdpRespDealerChatLoader_viewer";
};
export type PdpRespDealerChatLoader_viewer$data = PdpRespDealerChatLoader_viewer;
export type PdpRespDealerChatLoader_viewer$key = {
    readonly " $data"?: PdpRespDealerChatLoader_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerChatLoader_viewer",
  "selections": [
    {
      "condition": "isInteractivePdpChat",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyerChatLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '01ee0cfa5073c6f2c3e14cfdf4d74a2a';
export default node;
